import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import {
  Container,
  Typography,
  Divider,
  Modal,
  Box,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  TextField,
  Stack,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button
} from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import jaLocale from 'date-fns/locale/ja';
import { LoadingButton, DesktopDatePicker } from '@mui/lab';
import moment from 'moment';

// components
import Scrollbar from '../../components/Scrollbar';
//

// ----------------------------------------------------------------------

export default function ReceiptModal({ targetId = 0, open, onClose, updateDt, reload, quantity }) {
  const { SystemLib } = window;
  const navigate = useNavigate();

  useEffect(() => {}, []);

  useEffect(() => {
    if (targetId > 0) {
      // getItem(targetId);
      formik.setValues({
        quantity,
        note_receipt: ''
      });
    } else {
      formik.resetForm();
    }
  }, [targetId, updateDt]);

  // const getItem = async (id) => {
  //   const {
  //     data: { result, data }
  //   } = await SystemLib.api(
  //     `ship/item`,
  //     {
  //       id
  //     },
  //     'post'
  //   );
  //   if (result) {
  //     formik.setValues({
  //       quantity: data.quantity
  //     });
  //   }
  // };

  const yupNum = Yup.number()
    .typeError('数字を入力してください')
    .integer('整数を入力してください')
    .min(0, '0以上の数字を入れてください')
    // .max(max, `${max}以下の数字を入力してください`)
    .nullable()
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value));

  const FormSchema = Yup.object().shape({
    quantity: yupNum.required('入荷個数は必須です')
  });

  const formik = useFormik({
    initialValues: {
      quantity,
      note_receipt: ''
    },
    validationSchema: FormSchema,
    onSubmit: async () => {
      const { data } = await SystemLib.api(
        'layin/receipt',
        {
          order_id: targetId,
          stock_quantity: formik.values.quantity,
          note_receipt: formik.values.note_receipt
        },
        'post'
      );
      if (data.result) {
        reload(targetId);
        onClose();
      } else {
        alert('登録に失敗しました');
      }
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, isValid } = formik;

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
      }}
    >
      <FormikProvider value={formik}>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={styles.box} spacing={2} maxHeight="80%" overflow="scroll">
              <Stack direction="column" spacing={2} mt={0} mr={2} width="100%" mb={2}>
                <TextField
                  id="quantity"
                  label="入荷個数"
                  variant="outlined"
                  {...getFieldProps('quantity')}
                  error={Boolean(touched.quantity && errors.quantity)}
                  helperText={touched.quantity && errors.quantity}
                  onChange={formik.handleChange}
                  value={formik.values.quantity}
                  inputProps={{ style: { textAlign: 'center' } }}
                />
                <TextField
                  id="note_receipt"
                  label="備考"
                  variant="outlined"
                  {...getFieldProps('note_receipt')}
                  error={Boolean(touched.note_receipt && errors.note_receipt)}
                  helperText={touched.note_receipt && errors.note_receipt}
                  onChange={formik.handleChange}
                  value={formik.values.note_receipt}
                  multiline
                />
              </Stack>
              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                loading={isSubmitting}
                disabled={!isValid}
              >
                荷受する
              </LoadingButton>
            </Box>
          </Form>
        </LocalizationProvider>
      </FormikProvider>
    </Modal>
  );
}

const styles = {
  box: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'rgb(96,169,91)',
    borderRadius: 1,
    boxShadow: 24,
    p: 4
  }
};
